import { useMemo } from "react";

import { ZoneImportErrors } from "~/api/Api";
import Button from "~/components/mantine/button/Button.tsx";
import { groupZoneImportErrors } from "~/components/siteSpeed/dns/importUtils";
import { AlertCard } from "~/components/ui/card/AlertCard";

import styles from "./ImportZoneErrors.module.scss";

type Props = {
  errors: ZoneImportErrors;
  onClose: () => void;
};

export function ImportZoneErrors({ errors, onClose }: Props) {
  const grouped = useMemo(() => groupZoneImportErrors(errors), [errors]);

  const entries = Object.entries(grouped);

  if (!errors?.length) return null;

  return (
    <div className={styles.wrapper}>
      <AlertCard
        title="We’ve encountered errors while parsing the file"
        type="warning"
        actions={
          <>
            <Button variant="outlined" onClick={() => onClose()}>
              Close
            </Button>
          </>
        }
        content={
          <div className={styles.contentWrapper}>
            {entries.map(([message, items]) => (
              <div className={styles.group}>
                <span className={styles.title}>{message}</span>

                <pre className={styles.list}>
                  {items.map((err) => (
                    <div
                      key={`${err.line}-${err.text}`}
                      className={styles.item}
                    >
                      <div className={styles.line}>line {err.line}</div>
                      <div className={styles.code}>{err.text}</div>
                    </div>
                  ))}
                </pre>
              </div>
            ))}
          </div>
        }
      />
    </div>
  );
}
